module.exports = __webpack_public_path__ + "img/026_thumbnail.d718c3a6.jpg";